(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-header"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${
        this.header.offsetHeight
      }px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      


      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        


        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      


      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      


      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      


      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-image-banner"] && !Shopify.designMode) return;
  try {
    
  class CountdownTimer extends HTMLElement {
      constructor() {
          super();
      }

      init() {
          this.schemaTime = this.getAttribute('schema-time');
          this.timer = this.querySelector(".timer");
          this.countdown = new Date(this.schemaTime).getTime();
          this.second = 1000;
          this.minute = this.second * 60;
          this.hour = this.minute * 60;
          this.day = this.hour * 24;
          this.week = this.day * 7;

          this.startTimer();

          // Make timer visible after initializing
          setTimeout(() => this.timer.style.visibility = "visible", 1000);
      }

      padWithLeadingZero = (number) => (number < 10 ? '0' + number : number);

      isDateInPast(date) {
          const now = new Date().getTime();
          return date < now;
      }

      startTimer() {
          const timerElem = this.timer;
          this.timerInterval = setInterval(() => {
              const now = new Date().getTime();
              const distance = this.countdown - now;

              if (distance < 0) {
                  clearInterval(this.timerInterval);
                  timerElem.style.display = 'none'; // Hide timer if date is in the past
                  return;
              }

              const weekCalc = Math.floor(distance / this.week);
              const dayCalc = Math.floor((distance % this.week) / this.day);
              const hourCalc = Math.floor((distance % this.day) / this.hour);
              const minuteCalc = Math.floor((distance % this.hour) / this.minute);

              timerElem.querySelector('.js-timer-weeks').textContent = this.padWithLeadingZero(weekCalc);
              timerElem.querySelector('.js-timer-days').textContent = this.padWithLeadingZero(dayCalc);
              timerElem.querySelector('.js-timer-hours').textContent = this.padWithLeadingZero(hourCalc);
              timerElem.querySelector('.js-timer-minutes').textContent = this.padWithLeadingZero(minuteCalc);
          }, this.second);
      }

      disconnectedCallback() {
          clearInterval(this.timerInterval);
      }

      connectedCallback(){
          this.init();
          console.log("countdown timer was added to the page");

          const pastDate = this.isDateInPast(this.countdown);
          if(pastDate){
              this.timer.style.display = 'none'; // Hide timer if date is in the past
          }
      }
  }

  customElements.define('countdown-timer', CountdownTimer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-newsletter"]) return;
  try {
    
  // NEWSLETTER LOGIC
  document.addEventListener('DOMContentLoaded', function() {
    // Function to show one form and hide the other based on radio button selection
    function toggleForms() {
      // Check which radio button is selected
      const selectedLanguage = document.querySelector('input[name="language"]:checked').value;
      if (selectedLanguage === 'English') {
        document.getElementById('englishForm').style.display = 'block'; // Show the English form
        document.getElementById('germanForm').style.display = 'none'; // Hide the German form
      } else if (selectedLanguage === 'German') {
        document.getElementById('germanForm').style.display = 'block'; // Show the German form
        document.getElementById('englishForm').style.display = 'none'; // Hide the English form
      }
    }

    // Add change event listeners to the radio buttons
    document.querySelectorAll('input[name="language"]').forEach(radio => {
      radio.addEventListener('change', toggleForms);
    });

    // Call toggleForms function initially to set the correct form visibility on page load
    toggleForms();


      var accButtons = document.querySelectorAll('.accordion-button');
      accButtons.forEach(function(btn) {
        btn.addEventListener('click', function() {
            var panel = this.nextElementSibling;
            var arrow = this.querySelector('.arrow');
            if (panel.style.maxHeight) {
                panel.style.maxHeight = null;
                arrow.classList.remove('up'); // Remove 'up' class to rotate down
            } else {
                // Before opening a new panel, close all others and reset their arrows
                document.querySelectorAll('.panel').forEach(p => p.style.maxHeight = null);
                document.querySelectorAll('.accordion-button .arrow').forEach(a => a.classList.remove('up')); // Remove 'up' class from all arrows
                panel.style.maxHeight = panel.scrollHeight + "px";
                arrow.classList.add('up'); // Add 'up' class to rotate up
            }
        });
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
